import { getErrorMessage } from '@/api';
import {
  type Error as APIError,
  ErrorCode,
} from '@medsimples/doctor-onboarding-openapi-v2';

/**
 * Supposed to be used directly under `catch` statement of a request that sends OTP verification code
 * @param err catched error
 * @param options options for fallback texts
 * @return [title, message]
 */

export function handleOTPError(
  // biome-ignore lint/suspicious/noExplicitAny: intentional
  err: any,
  options: { fallbackMessage?: string; fallbackTitle?: string } = {},
) {
  const message = options?.fallbackMessage ?? 'Ocorreu um erro inesperado!';
  const title = options?.fallbackTitle ?? 'Ops!';
  const apiError: APIError = err?.body.error;

  if (apiError?.code) {
    switch (apiError.code) {
      case ErrorCode.UserNotFound:
        return ['Cadastro inexistente', 'Informação não existente.'];
      case ErrorCode.UserEmailOrPhoneTaken:
        return ['Cadastro existente', 'Este dado já está em utilização'];
      default:
        return [title, getErrorMessage(apiError.code)];
    }
  }

  return [title, message];
}
